export default __webpack_public_path__ + "static/media/butter3.c6fff9b7.jpg";